<template>
	<div class="friend-page">
		<div class="friend-container">
			<div class="friend-left">
				<friend-group-list ref="friendGroupList" @select-friend="onSelectFriend" />
			</div>
			<div class="friend-right">
				<div class="friend-detail" v-if="selectedFriend">
					<div class="info-item">
						<head-image
							:size="160"
							:url="selectedFriend.headImage"
							:name="selectedFriend.nickName"
							radius="10%"
							@click.native="showFullImage()"
						/>
						<div class="info-content">
							<el-descriptions title="好友信息" class="description" :column="1">
								<el-descriptions-item label="用户名">{{ selectedFriend.userName }}</el-descriptions-item>
								<el-descriptions-item label="聊天号">{{ selectedFriend.userCode }}</el-descriptions-item>
								<el-descriptions-item label="昵称">{{ selectedFriend.nickName }}</el-descriptions-item>
								<el-descriptions-item label="备注">
									<el-input
										v-model="remarkName"
										size="small"
										placeholder="设置备注"
										style="width: 200px; vertical-align: middle; margin-top: -5px;"
										@blur="updateRemarkName"
									></el-input>
								</el-descriptions-item>
								<el-descriptions-item label="性别">{{ selectedFriend.sex === 0 ? "男" : "女" }}</el-descriptions-item>
								<el-descriptions-item label="签名">{{ selectedFriend.signature }}</el-descriptions-item>
							</el-descriptions>
							<div class="info-actions">
								<el-button type="primary" icon="el-icon-position" @click="onSendMessage">发消息</el-button>
								<el-button type="default" icon="el-icon-user" @click="onShareCard">推送名片</el-button>
								<el-button type="text" @click="onMoveFriend">移动到分组</el-button>
								<el-button type="danger" icon="el-icon-delete" @click="onDeleteFriend">删除好友</el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 移动好友对话框 -->
		<move-friend-dialog
			:visible.sync="moveDialogVisible"
			:friend-id="selectedFriend ? selectedFriend.id : null"
			@success="onMoveSuccess"
		/>
		<forward-dialog ref="forwardDialog" :exclude-ids="forwardExcludeIds" @confirm="onConfirmShareTarget"></forward-dialog>
	</div>
</template>

<script>
import FriendGroupList from '@/components/friend/FriendGroupList.vue'
import MoveFriendDialog from '@/components/friend/MoveFriendDialog.vue'
import HeadImage from '@/components/common/HeadImage.vue'
import ForwardDialog from '@/components/chat/ForwardDialog.vue'

export default {
	name: 'Friend',
	components: {
		FriendGroupList,
		MoveFriendDialog,
		HeadImage,
		ForwardDialog
	},
	data() {
		return {
			selectedFriend: null,
			moveDialogVisible: false,
			remarkName: ''
		}
	},
  computed: {
    forwardExcludeIds() {
      // 排除本人和名片所属人
      const selfId = this.$store.state.userStore.userInfo?.id;
      const cardOwnerId = this.selectedFriend ? this.selectedFriend.id : null;
      return [selfId, cardOwnerId].filter(id => id != null);
    }
  },
	methods: {
		onSelectFriend(friend) {
			this.loadUserInfo(friend)
		},
		async loadUserInfo(friend) {
			try {
				const user = await this.$http.get(`/user/find/${friend.id}`)
				this.selectedFriend = user
				this.remarkName = friend.remarkName || ''
				// 如果发现好友的头像和昵称改了，进行更新
				if (user.headImageThumb !== friend.headImage || user.nickName !== friend.nickName) {
					await this.updateFriendInfo(friend, user)
				}
			} catch (error) {
				this.$message.error('获取好友信息失败')
			}
		},
		async updateFriendInfo(friend, user) {
			try {
				const updatedFriend = {
					...friend,
					headImage: user.headImageThumb,
					nickName: user.nickName,
					remarkName: this.remarkName
				}
				await this.$http.put('/friend/update', updatedFriend)
				this.$store.commit('updateFriend', updatedFriend)
				this.$store.commit('updateChatFromFriend', updatedFriend)
			} catch (error) {
				this.$message.error('更新好友信息失败')
			}
		},
		onMoveFriend() {
			this.moveDialogVisible = true
		},
		onMoveSuccess() {
			// 刷新分组列表
			this.$refs.friendGroupList.loadGroups()
		},
		async onDeleteFriend() {
			try {
				await this.$confirm(`确认删除'${this.selectedFriend.nickName}',并清空聊天记录吗?`, '确认解除?', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				const friendId = this.selectedFriend.id
				await this.$http.delete(`/friend/delete/${friendId}`)
				this.$message.success('删除好友成功')
				// 移除私聊
				this.$store.commit('removePrivateChat', friendId)
				this.selectedFriend = null
				// 刷新分组列表
				this.$refs.friendGroupList.loadGroups()
			} catch (error) {
				console.log("error 删除好友失败",error)
				if (error !== 'cancel') {
					this.$message.error('删除失败')
				}
			}
		},
		showFullImage() {
			if (this.selectedFriend.headImage) {
				this.$store.commit('showFullImageBox', this.selectedFriend.headImage)
			}
		},
		async updateRemarkName() {
			if (!this.selectedFriend) return
			try {
				const friend = { ...this.selectedFriend, remarkName: this.remarkName }
				await this.$http.put('/friend/update', friend)
				this.$message.success('备注更新成功')
				this.$store.commit('updateChatFromFriend', friend)
				this.$refs.friendGroupList.loadGroups()
			} catch (error) {
				this.$message.error('备注更新失败')
			}
		},
		onSendMessage() {
			if (!this.selectedFriend) return
			const chat = {
				type: 'PRIVATE',
				targetId: this.selectedFriend.id,
				showName: this.remarkName || this.selectedFriend.nickName,
				headImage: this.selectedFriend.headImageThumb,
			}
			this.$store.commit('openChat', chat)
			this.$store.commit('activeChat', 0)
			this.$router.push('/home/chat')
		},
		onShareCard() {
			if (!this.selectedFriend) return
			this.$refs.forwardDialog.open();
		},
		onConfirmShareTarget(target) {
			if (!this.selectedFriend) return
			const card = {
				id: this.selectedFriend.id,
				nickName: this.remarkName || this.selectedFriend.nickName,
				headImage: this.selectedFriend.headImageThumb || this.selectedFriend.headImage,
				userCode: this.selectedFriend.userCode
			};
			const msg = {
				type: this.$enums.MESSAGE_TYPE.CARD,
				content: JSON.stringify(card)
			};
			if (target.type === 'GROUP') {
				msg.groupId = target.targetId
			} else {
				msg.recvId = target.targetId
			}
			this.$http({ url: `/message/${target.type.toLowerCase()}/send`, method: 'post', data: msg }).then((m) => {
				m.selfSend = true;
				const chatInfo = { type: target.type, targetId: target.targetId };
				this.$store.commit('openChat', { ...chatInfo, showName: target.showName, headImage: '' });
				this.$store.commit('insertMessage', [m, chatInfo]);
				this.$message.success('已推送名片');
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.friend-page {
	height: 100%;
	background-color: #f5f7fa;

	.friend-container {
		display: flex;
		height: 100%;

		.friend-left {
			width: 300px;
			border-right: 1px solid #eee;
		}

		.friend-right {
			flex: 1;
			padding: 20px;

			.friend-detail {
				background-color: #fff;
				border-radius: 4px;
				padding: 20px;

				.info-item {
					display: flex;
					padding: 20px;
					text-align: center;

					.info-content {
						margin-left: 40px;
						text-align: left;
						flex: 1;

						.description {
							margin-bottom: 20px;
						}

						.info-actions {
							margin-top: 20px;
							display: flex;
							gap: 10px;
						}
					}
				}
			}
		}
	}
}
</style>
